import React from "react";

export class DropDownAction extends React.Component {
  state = {
    isOpen: false,
    openUp: false,
    currentItem: "",
  };

  container = React.createRef();
  menu = React.createRef();
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.container.current &&
      !this.container.current.contains(event.target)
    ) {
      this.setState({ isOpen: false });
    }
  };

  positionMenu = () => {
    if (!this.container.current || !this.menu.current) return;
    const containerRect = this.container.current.getBoundingClientRect();
    const menuHeight = Math.max(
      this.menu.current.scrollHeight,
      this.menu.current.getBoundingClientRect().height
    );
    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;
    const availableBelow = Math.max(0, viewportHeight - containerRect.bottom);
    const availableAbove = Math.max(0, containerRect.top);
    const openUp =
      menuHeight > availableBelow && availableAbove > availableBelow;

    if (openUp !== this.state.openUp) this.setState({ openUp });
  };

  toggleOpen = () =>
    this.setState(
      (previousState) => ({
        isOpen: !previousState.isOpen,
        openUp: false,
      }),
      () => {
        if (this.state.isOpen) this.positionMenu();
      }
    );

  render() {
    const { title, items, drop, customStyle, ulStyle, ...rest } = this.props;
    const menuClass = `dropdown-menu${this.state.isOpen ? " show" : ""}`;
    return (
      <div
        className={drop}
        onClick={this.toggleOpen}
        {...rest}
        ref={this.container}
      >
        <button
          className="btn"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          style={customStyle}
        >
          {title}
        </button>
        <ul
          ref={this.menu}
          className={menuClass}
          aria-labelledby="dropdownMenuButton"
          style={{
            ...ulStyle,
            ...(this.state.openUp
              ? { top: "auto", bottom: "100%" }
              : {}),
          }}
        >
          {items.length &&
            items.map((item, index, array) => (
              <li
                key={index}
                className="dropdown-item"
                style={
                  index + 1 === array.length
                    ? { padding: "0px", margin: "0", height: "100%" }
                    : { padding: "0px", margin: "0", height: "100%" }
                }
              >
                {item}
              </li>
            ))}
        </ul>
      </div>
    );
  }
}

export default DropDownAction;
